import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-sidebar',
  templateUrl: 'sidebar.component.html'
})
export class SidebarComponent {

  @Input() item: any;
  @Input() components: any;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor(
  ) {
  }

  emitSendEvent(event?: any) {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.sendEvent.emit({ action: 'close' });
  }

  getComponentTitle(c: any): string {
    if (!c) return 'Item';
    if (c.title && typeof c.title === 'object' && c.title.text) {
      return c.title.text;
    }
    if (typeof c.title === 'string' && c.title) {
      return c.title;
    }
    if (c.titleText) {
      return c.titleText;
    }
    if (c.label) {
      return c.label;
    }
    if (c.type) {
      return c.type;
    }
    return 'Item';
  }

  getComponentIcon(c: any): string {
    if (typeof c === 'string') {
      if (c === 'Página inicial') return 'fa fa-home';
      if (c === 'Minha página') return 'fa fa-user';
      return 'fa fa-bookmark';
    }
    
    if (!c) return 'fa fa-clipboard';
    
    if (c.icon) {
      if (c.icon.startsWith('bi-') || c.icon.startsWith('bi ')) {
        return 'bi ' + c.icon;
      }
      if (c.icon.startsWith('fa-') || c.icon.startsWith('fa ')) {
        return c.icon;
      }
    }

    const type = c.type || '';

    const typeIcons: { [key: string]: string } = {
      'home': 'fa fa-home',
      'my_page': 'fa fa-user',
      'cursos-sessao': 'fa fa-graduation-cap',
      'aulas-rapidas-sessao': 'fa fa-book',
      'journey': 'fa fa-compass',
      'mini': 'fa fa-comments-o',
      'videos': 'fa fa-play-circle',
      'videos-sessao': 'fa fa-play-circle',
      'artigos': 'fa fa-file-text-o',
      'free': 'fa fa-laptop',
      'eventos': 'fa fa-calendar',
      'evento-sessao': 'fa fa-calendar-check-o',
      'news-section': 'fa fa-newspaper-o',
      'feed': 'fa fa-rss',
      'forum': 'fa fa-comments',
      'forum-theme': 'fa fa-comments',
      'forum-theme-sidebar': 'fa fa-comments',
      'users': 'fa fa-users',
      'usuarios-sidebar': 'fa fa-user-plus',
      'jobs': 'fa fa-briefcase',
      'vacancies': 'fa fa-id-card-o',
      'benefits': 'fa fa-gift',
      'conquistas': 'fa fa-trophy',
      'pontos': 'fa fa-star',
      'credits': 'fa fa-credit-card',
      'shortcuts': 'fa fa-th-list',
      'menu': 'fa fa-bars',
      'tecnico': 'fa fa-file-pdf-o',
      'main-tecnico': 'fa fa-folder-open',
      'assessment': 'fa fa-check-square-o',
      'slides': 'fa fa-sliders',
      'in_progress': 'fa fa-hourglass-half',
      'influenciadores': 'fa fa-star-o',
      'banner': 'fa fa-picture-o',
      'banner-link': 'fa fa-external-link',
      'studio': 'fa fa-video-camera',
      'gallery': 'fa fa-picture-o',
      'html': 'fa fa-code',
      'multicontas': 'fa fa-cubes'
    };

    return typeIcons[type] || 'fa fa-clipboard';
  }

  isItemVisible(title: string, componentObj?: any): boolean {
    if (!this.item || !this.item.sidebarSelectedItems || !Array.isArray(this.item.sidebarSelectedItems) || this.item.sidebarSelectedItems.length === 0) {
      return true;
    }
    return this.item.sidebarSelectedItems.some((s: any) => {
      if (typeof s === 'string') return s === title;
      if (s && s.title === title) return true;
      if (s && componentObj && componentObj.id && s.id === componentObj.id) return true;
      return false;
    });
  }

  getPhoto(target: any, $event: any): void {
    if (target === 'logoLight') {
      this.item.logoLight = $event.path;
    }
    if (target === 'logoDark') {
      this.item.logoDark = $event.path;
    }
    if (target === 'logoFooter') {
      this.item.logoFooter = $event.path;
    }
    if (target === 'logoEAD') {
      this.item.logoEAD = $event.path;
    }
    if (target === 'logoHelpdesk') {
      this.item.logoHelpdesk = $event.path;
    }
    if (target === 'emblem') {
      this.item.emblem = $event.path;
    }

  }
}
